import { Component, OnInit, HostBinding, inject, input } from "@angular/core";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-control-section",
  templateUrl: "./control-section.component.html",
  styleUrls: ["./control-section.component.scss"],
  standalone: false,
})
export class ControlSectionComponent implements OnInit {
  private card = inject(CardComponent, { optional: true });

  readonly title = input<string>(undefined);
  readonly subtitle = input<string>(undefined);

  @HostBinding("class") get class() {
    return {
      "control-section-card": !!this.card,
    };
  }

  ngOnInit(): void {}
}
